export const BUCKET_NAME = 'cp-profilepictures';
export const ACCESS_KEY_ID = 'AKIAI2IU3HUJ4JLB7P2A';
export const SECRET_ACCESS_KEY = '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';



// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/addAccount/.constants.js